// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:  {
    apiKey: "AIzaSyCIxvA1RaokbB2JQLBYZoeXngBW2XB_T_Y",
    authDomain: "bright-plans.firebaseapp.com",
    databaseURL: "https://bright-plans.firebaseio.com",
    projectId: "bright-plans",
    storageBucket: "bright-plans.appspot.com",
    messagingSenderId: "85933831393",
    appId: "1:85933831393:web:d00326dca962b1867db3a0",
    measurementId: "G-V953JJQXKH"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
